<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <g clip-path="url(#clip0_2706_36986)">
      <path
        d="M6.00016 5.99967H6.00683M10.0002 9.99967H10.0068M10.6668 5.33301L5.3335 10.6663M6.3335 5.99967C6.3335 6.18377 6.18426 6.33301 6.00016 6.33301C5.81607 6.33301 5.66683 6.18377 5.66683 5.99967C5.66683 5.81558 5.81607 5.66634 6.00016 5.66634C6.18426 5.66634 6.3335 5.81558 6.3335 5.99967ZM10.3335 9.99967C10.3335 10.1838 10.1843 10.333 10.0002 10.333C9.81607 10.333 9.66683 10.1838 9.66683 9.99967C9.66683 9.81558 9.81607 9.66634 10.0002 9.66634C10.1843 9.66634 10.3335 9.81558 10.3335 9.99967ZM14.6668 7.99967C14.6668 11.6816 11.6821 14.6663 8.00016 14.6663C4.31826 14.6663 1.3335 11.6816 1.3335 7.99967C1.3335 4.31778 4.31826 1.33301 8.00016 1.33301C11.6821 1.33301 14.6668 4.31778 14.6668 7.99967Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2706_36986">
        <rect
          width="16"
          height="16"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
